import React from 'react'
import {MenuItem} from './MenuItem'
import {MenuInnerWithSub} from './MenuInnerWithSub'
import {MegaMenu} from './MegaMenu'
import {useIntl} from 'react-intl'
import {useAuth} from '../../../../app/modules/auth'

export function MenuInner() {
  const intl = useIntl()
  const {currentUser} = useAuth()
//alert(currentUser?.user_type)
  return (
    <>
      <MenuItem title={intl.formatMessage({id: 'MENU.DASHBOARD'})} to='/home' />
      {currentUser && currentUser.user_type == "student" && <MenuItem title='ผลงานส่วนตัว' to='/personal_publication' />}
      <MenuItem title='เกี่ยวกับเรา' to='/about_us' />
      <MenuItem title='การจัดการความรู้' to='/knowledge_management' />
      <MenuItem title='แนวปฏิบัติที่ดี' to='/guideline' />

      <MenuInnerWithSub
        title='สินทรัพย์ทางความรู้อื่นๆ ของคณะ'
        to='/multi_knowledge'
        hasArrow={true}
        menuPlacement='bottom-start'
        menuTrigger='click'
      >
            <MenuItem to='/multi_knowledge?mid=3&mname=รายละเอียดกระบวนการทำงาน' title='รายละเอียดกระบวนการทำงาน' hasBullet={true} />
            <MenuItem to='/multi_knowledge?mid=4&mname=กระบวนการเทียบเคียง' title='กระบวนการเทียบเคียง' hasBullet={true} />
            <MenuItem to='/multi_knowledge?mid=5&mname=ภาพและวีดิโอการนำเสนอ การประชุม สัมมนา' title='ภาพและวีดิโอการนำเสนอ การประชุม สัมมนา' hasBullet={true} />
            <MenuItem to='/multi_knowledge?mid=6&mname=แผนภาพ โครงสร้าง โครงร่างการบริการ' title='แผนภาพ โครงสร้าง โครงร่างการบริการ' hasBullet={true} />
            <MenuItem to='/multi_knowledge?mid=7&mname=ฐานข้อมูล' title='ฐานข้อมูล' hasBullet={true} />
            <MenuItem to='/multi_knowledge?mid=8&mname=เอกสารอบรมสัมมนา เอกสารประกอบการสอน' title='เอกสารอบรมสัมมนา เอกสารประกอบการสอน' hasBullet={true} />
            <MenuItem to='/multi_knowledge?mid=9&mname=รายงานประจำปี' title='รายงานประจำปี' hasBullet={true} />
            <MenuItem to='/multi_knowledge?mid=10&mname=ความรู้ในคน การเรียนรู้ระดับองค์กร' title='ความรู้ในคน การเรียนรู้ระดับองค์กร' hasBullet={true} />

      </MenuInnerWithSub>

      {/*<MenuInnerWithSub
        title='Crafted'
        to='/crafted'
        menuPlacement='bottom-start'
        menuTrigger='click'
      >
        <MenuInnerWithSub
          title='Pages'
          to='/crafted/pages'
          icon='/media/icons/duotune/general/gen022.svg'
          hasArrow={true}
          menuPlacement='right-start'
          menuTrigger={`{default:'click', lg: 'hover'}`}
        >
          <MenuInnerWithSub
            title='Profile'
            to='/crafted/pages/profile'
            hasArrow={true}
            hasBullet={true}
            menuPlacement='right-start'
            menuTrigger={`{default:'click', lg: 'hover'}`}
          >
            <MenuItem to='/crafted/pages/profile/overview' title='Overview' hasBullet={true} />
            <MenuItem to='/crafted/pages/profile/projects' title='Projects' hasBullet={true} />
            <MenuItem to='/crafted/pages/profile/campaigns' title='Campaigns' hasBullet={true} />
            <MenuItem to='/crafted/pages/profile/documents' title='Documents' hasBullet={true} />
            <MenuItem
              to='/crafted/pages/profile/connections'
              title='Connections'
              hasBullet={true}
            />
          </MenuInnerWithSub>
          <MenuInnerWithSub
            title='Wizards'
            to='/crafted/pages/wizards'
            hasArrow={true}
            hasBullet={true}
            menuPlacement='right-start'
            menuTrigger={`{default:'click', lg: 'hover'}`}
          >
            <MenuItem to='/crafted/pages/wizards/horizontal' title='Horizontal' hasBullet={true} />
            <MenuItem to='/crafted/pages/wizards/vertical' title='Vertical' hasBullet={true} />
          </MenuInnerWithSub>
        </MenuInnerWithSub>

        <MenuInnerWithSub
          title='Accounts'
          to='/crafted/accounts'
          icon='/media/icons/duotune/communication/com006.svg'
          hasArrow={true}
          menuPlacement='right-start'
          menuTrigger={`{default:'click', lg: 'hover'}`}
        >
          <MenuItem to='/crafted/account/overview' title='Overview' hasBullet={true} />
          <MenuItem to='/crafted/account/settings' title='Settings' hasBullet={true} />
        </MenuInnerWithSub>

        <MenuInnerWithSub
          title='Errors'
          to='/error'
          icon='/media/icons/duotune/technology/teh004.svg'
          hasArrow={true}
          menuPlacement='bottom-start'
          menuTrigger={`{default:'click', lg: 'hover'}`}
        >
          <MenuItem to='/error/404' title='Error 404' hasBullet={true} />
          <MenuItem to='/error/500' title='Error 500' hasBullet={true} />
        </MenuInnerWithSub>

        <MenuInnerWithSub
          title='Widgets'
          to='/crafted/widgets'
          icon='/media/icons/duotune/general/gen025.svg'
          hasArrow={true}
          menuPlacement='right-start'
          menuTrigger={`{default:'click', lg: 'hover'}`}
        >
          <MenuItem to='/crafted/widgets/lists' title='Lists' hasBullet={true} />
          <MenuItem to='/crafted/widgets/statistics' title='Statistics' hasBullet={true} />
          <MenuItem to='/crafted/widgets/charts' title='Charts' hasBullet={true} />
          <MenuItem to='/crafted/widgets/mixed' title='Mixed' hasBullet={true} />
          <MenuItem to='/crafted/widgets/tables' title='Tables' hasBullet={true} />
          <MenuItem to='/crafted/widgets/feeds' title='Feeds' hasBullet={true} />
        </MenuInnerWithSub>
      </MenuInnerWithSub> */}

      {/*<MenuInnerWithSub title='Apps' to='/apps' menuPlacement='bottom-start' menuTrigger='click'>
        <MenuInnerWithSub
          title='Chat'
          to='/apps/chat'
          icon='/media/icons/duotune/communication/com012.svg'
          hasArrow={true}
          menuPlacement='right-start'
          menuTrigger={`{default:'click', lg: 'hover'}`}
        >
          <MenuItem to='/apps/chat/private-chat' title='Private Chat' hasBullet={true} />
          <MenuItem to='/apps/chat/group-chat' title='Group Chart' hasBullet={true} />
          <MenuItem to='/apps/chat/drawer-chat' title='Drawer Chart' hasBullet={true} />
        </MenuInnerWithSub>
        <MenuInnerWithSub
          title='Devs'
          to='/apps/devs'
          icon='/media/icons/duotune/communication/com010.svg'
          hasArrow={true}
          menuPlacement='right-start'
          menuTrigger={`{default:'click', lg: 'hover'}`}
        >
          <MenuItem to='/apps/devs/question' title='Question' hasBullet={true} />
          <MenuItem to='/apps/devs/tag' title='Tag' hasBullet={true} />
          <MenuItem to='/apps/devs/search' title='Search' hasBullet={true} />
          <MenuItem to='/apps/devs/ask' title='Ask' hasBullet={true} />
        </MenuInnerWithSub>
        <MenuItem
          icon='/media/icons/duotune/general/gen051.svg'
          to='/apps/user-management/users'
          title='User management'
        />
      </MenuInnerWithSub>  */}

      {/*<MenuInnerWithSub
        isMega={true}
        title='Mega menu'
        to='/mega-menu'
        menuPlacement='bottom-start'
        menuTrigger='click'
      >
        <MegaMenu />
      </MenuInnerWithSub>*/}
    </>
  )
}
